import { useEffect, useRef } from 'react';

/**
 * The `usePrevious` hook gives you access to the value of a state of the previous
 * render cycle.
 * @public
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function usePrevious<T = any>(value: T) {
  const ref = useRef<T>(undefined);
  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
}
